<template>
    <modal :modal-id="modalId"
           :class="modalBodyClass"
                     :title="modalTitle"
                     :preloader="preloader"
           :modalExtraButton="modalExtraButton"
                     @submit="submit"
                     @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="col-md-9 pl-1 pr-0 mb-1"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `admin/app/careers/${inputs.id}` : `admin/app/careers`'>

                <div class="row col-sm-12 justify-content-between half-width-container pr-0 mb-4">
                    <div class="form-group row align-items-center md-half-width">
                        <label v-if="this.inputs.status !== 4" for="inputs_name" class="col-sm-12 mb-0">
                            {{ $t('job') }} {{ $t('(internal_name)') }}
                        </label>
                        <label v-else for="inputs_name" class="col-sm-12 mb-0">
                            {{ $t('job_template') }} {{ $t('(internal_name)') }}
                        </label>
                        <app-input id="inputs_job"
                                   class="col-sm-12 pr-0"
                                   type="text"
                                   v-model="inputs.job"
                                   :placeholder="$t('text_type_input')"
                                   :required="true"/>

                    </div>
                    
                </div>
            

                <div class="row align-items-center mb-30 mt-4">
                    <div v-if="this.inputs.status !== 4" class="form-group col-sm-12 col-md-4 p-0">
                        <label for="inputs_status" class="col-sm-12 mb-0 cursor-help" @click.prevent="isNoteStatusHidden = !isNoteStatusHidden">
                            {{ $t('displayed_on_careers_site') }} <app-icon :name="'help-circle'" width="18" height="18"/>
                        </label>
                        <app-input id="inputs_status"
                                   class="col-sm-12"
                                   type="select"
                                   v-model="inputs.status"
                                   :list="statusLists"/>

                    </div>
                    <div class="form-group col-sm-12 col-md-4 p-0">
                        <label for="inputs_czisco" class="col-sm-12 mb-0">
                            CZ-ISCO 
                        </label>
                        <app-input id="inputs_czisco"
                                   class="col-sm-12"
                                   type="number"
                                   :minNumber="0"
                                   :maxNumber="999999999"
                                   v-model="inputs.czisco"/>

                    </div>
                    <div class="form-group col-sm-12 col-md-4 p-0">
                        <label for="inputs_kzam" class="col-sm-12 mb-0">
                            KZam 
                        </label>
                        <app-input id="inputs_kzam"
                                   class="col-sm-12"
                                   type="number"
                                   :minNumber="0"
                                   :maxNumber="999999999"
                                   v-model="inputs.kzam"/>

                    </div>
                    
                </div>
                <div v-if="!isNoteStatusHidden" class="note note-info row ml-1 mt-3 p-4 col-sm-12 mb-5">
                    <div class="col-md-1">
                        <app-icon :name="'eye-off'" width="30" height="30"/>
                    </div>
                    <div class="col-md-8">

                        {{ $t('adverts_archive_note_italic') }}
                    </div>
                </div>


                <div class="form-group row align-items-center mb-2">
                    <label for="inputs_note" class="col-sm-12 mb-0">
                        {{ $t('advert_note') }} {{ $t('(internal)') }}
                    </label>
                    <app-input id="inputs_note"
                               class="col-sm-12"
                               :class="inputs.note ? 'note_added' : ''"
                               type="textarea"
                               v-model="inputs.note"
                               :placeholder="$t('text_type_input')"
                               />
                    <div class="col-sm-12 text-muted text-right"><i>{{ $t('advert_note_italic') }}</i></div>
                </div>
                

                <div class="row col-sm-12 justify-content-between half-width-container pr-0 mt-5">
                    <div class="form-group row align-items-center col-sm-8 pl-0 pr-0">
                        <label for="inputs_title" class="col-sm-12 mt-3 mb-0 cursor-help" @click.prevent="isNoteStatusHidden = !isNoteStatusHidden">
                            {{ $t('advert_title_and_text') }} <app-icon :name="'help-circle'" width="18" height="18"/>
                        </label>
                        <app-input id="inputs_title"
                                    class="col-sm-12 pr-0"
                                    type="text"
                                   v-model="inputs.title"
                                   :placeholder="$t('text_type_input')"/>
                    </div>
                    <div class="form-group row align-items-center col-sm-4 pl-0 pr-0">
                        <div class="col-sm-12 pr-0 mb-0">
                            <span class="template-selection">
                                <label for="inputs_title" class="col-sm-9 mt-3 mb-0 pl-0">
                                    {{ $t('choose_from_template') }}
                                </label>
                                <a href="/mail-templates" target="_blank" class="col-2 mt-1 text-right text-muted" :title="$t('edit_templates')">
                                    <app-icon :name="'edit'" width="18" height="18"/>
                                </a>

                                <app-input id="inputs_template"
                                   class="pr-0"
                                   type="select"
                                   v-model="template"
                                   :list="templateOptions"/>
                            </span>
                        </div>

                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <app-overlay-loader v-if="editorPreloader"/>
                    <app-input v-if="finishedGetData" id="inputs_text"
                               class="col-sm-12"
                               type="text-editor"
                               v-model="inputs.advert"
                               :placeholder="$t('text_type_input')"
                               />
                    <app-input v-if="editorPreloader"
                               id="inputs_text_blind"
                               class="col-sm-12"
                               :class="{'loading-opacity': editorPreloader}"
                               type="textarea"/>

                    <div class="col-sm-12 mt-2 mb-4 text-center">

                            <button v-if="this.inputs.status !== 4"
                                type="button"
                                class="btn btn-primary btn-sm mr-3"
                                @click.prevent="submitTemplate()">

                                <app-icon :name="'layout'" width="18" height="18" class="mr-2"/>
                                {{ $t('save_as_template') }}
                            </button>

                            <button class="btn btn-primary btn-sm" @click.prevent="copyTextareaText">
                                <app-icon :name="'copy'" width="18" height="18" class="mr-2"/>
                                {{ $t('copy_text_advert') }}
                            </button>
                    </div>

                </div>
                

                
                <div v-if="this.inputs.job && this.inputs.status !== 4 && this.selectedUrl" class="row mb-3">
                    <div class="form-group col-sm-12 col-md-6 mb-15">
                        <label for="inputs_location" class="col-sm-12 mb-0 p-0">
                            {{ $t('location') }}
                        </label>
                        <app-input id="inputs_location"
                                    class="col-sm-12 p-0"
                                    type="text"
                                    v-model="inputs.location"
                                    :placeholder="$t('text_type_input')"/>
                    </div>
                    <div class="form-group col-sm-12 col-md-6 mb-15"        :class="inputs.status == 1 ? '' : 'd-none'">
                        <label for="inputs_url" class="col-sm-12 mb-0 p-0">
                            {{ $t('advert_url') }}
                        </label>

                        <app-input id="inputs_url"
                                   class="col-sm-12 p-0"
                                   type="text"
                                   v-model="inputs.url"
                                   ref="textToCopy"
                                   :data-slug="slug"
                                   :title="$t('click_to_copy')"
                                   :readOnly="true"
                                   @click="copyText"
                                   :required="true"/>
                    </div>

                </div>
                


                <div v-if="this.selectedUrl" class="row">

                    <div class="col-sm-12 col-md-6 form-group">
                        <label for="" class="col-sm-12 mb-0 p-0">
                            {{ $t('superiors') }}
                        </label><br>
                        <button type="button"
                                class="btn btn-primary mt-1 mr-2"
                                @click.prevent="closeModalAndOpen('notification')">

                            {{ $t('share_with_manager') }}
                        </button>
                    </div>
                    <div v-if="inputs.status == 1 && this.selectedUrl" class="col-sm-12 col-md-6 form-group">
                        <label for="" class="col-sm-12 mb-0 p-0">
                            {{ $t('share_advert_on_social') }}
                        </label><br>
                        <button type="button"
                                class="btn btn-primary btn-circle mt-1"
                                @click.prevent="linkedInShare(inputs.url, 'LinedIn Share', inputs.job + ', ' + inputs.location, 520, 350)">
                            <app-icon :name="'linkedin'" width="20" height="20"/>
                        </button>
                        <button type="button"
                                class="btn btn-primary btn-circle mt-1"
                                @click.prevent="fbShare(inputs.url, 'Fb Share', inputs.job + ', ' + inputs.location, 520, 350)">
                            <app-icon :name="'facebook'" width="20" height="20"/>
                        </button>
                        <button type="button"
                                class="btn btn-primary btn-circle mt-1"
                                @click.prevent="twitterShare(inputs.url, 'Fb Share', inputs.job + ', ' + inputs.location, 520, 350)">
                            <app-icon :name="'twitter'" width="20" height="20"/>
                        </button>

                    </div>
                </div>


                <br>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import {ModalMixin} from "../../../../../Mixins/ModalMixin";

    export default {
        name: "AddModal",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
            modalExtraButton: String
        },
        watch: {
          template: {
            sync: true,
            handler (val, oldVal) {
                if(val != 0){
                    this.getTemplateData();
                }
            }
          }
        },
        data() {
            return {
                preloader: false,
                editorPreloader: false,
                finishedGetData: false,
                inputs: {
                    education: '0',
                    status: 1,
                    job: '',
                    url: '',
                    czisco: '',
                    kzam: '',

                },
                template: 0,
                isNotePreselectionHidden: true,
                isNoteStatusHidden: true,
                lastAdvert: 0,
                templateOptions: [
                    {id: 0, value: this.$t('select'),},
                ],
                statusLists: [
                    {id: 1, value: this.$t('Yes'),},
                    {id: 2, value: this.$t('No'),},
                ],
                preselectionLists: [
                    {id: '0', value: "Práce v kanceláři",},
                    {id: '1', value: "Práce v terénu, přímý kontakt se zákazníky",},
                    {id: '2', value: "Jiné (uveďte)",},
                ],

                educationLists: [
                    {id: '43', value: "Vysokoškolské vzdělání (doktorské)"},
                    {id: '42', value: "Vysokoškolské vzdělání (magisterské)"},
                    {id: '41', value: "Vysokoškolské vzdělání (bakalářské)"},
                    {id: '40', value: "Vysokoškolské vzdělání"},
                    {id: '30', value: "Vyšší odborné vzdělání"},
                    {id: '24', value: "Střední vzdělání s maturitní zkouškou"},
                    {id: '23', value: "Střední vzdělání s výučním listem"},
                    {id: '22', value: "Střední vzdělání (bez výučního listu a bez maturitní zkoušky)"},
                    {id: '21', value: "Střední odborné vzdělání"},
                    {id: '20', value: "Středoškolské vzdělání"},
                    {id: '10', value: "Základní vzdělání"},
                    {id: '0', value: "Vzdělání není podstatné"},
                ],
                modalId: 'add-edit-Modal',
                modalBodyClass: 'simple-modal',
                modalTitle: this.$t('add'),
            }
        },
        created() {

            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.getLastJobId();
                this.preloader = true;
            } else {
                if(this.tableId == 'careerTemplates'){
                    this.inputs.status = 4;
                }
                this.finishedGetData = true;
                this.getLastJobId();
            }


            // Display available job templates
            let url = 'admin/app/careers?filter_with_status_id=4&per_page=500';
            this.axiosGet(url).then(response => {

                const templateOptionsArray = response.data.data.map(({
                  job: value,
                  ...rest
                }) => ({
                  value,
                  ...rest
                }));

                this.templateOptions = templateOptionsArray;
                this.templateOptions.unshift({"id": 0, "value": this.$t('select')});

            }).catch(({response}) => {
            }).finally(() => {
            });

        },
        computed: {
            slug: function() {
                var slug = this.sanitizeTitle(this.inputs.job);

                var getUrl = window.location;
                var baseUrl = getUrl .protocol + "//" + getUrl.host + "/";

                if(this.inputs.id){
                    this.inputs.url = baseUrl+'kariera/'+this.inputs.id+'-'+slug;
                } else {
                    this.inputs.url = baseUrl+'kariera/'+this.newJobId+'-'+slug;
                }

                return slug;
            },

        },
        methods: {

            /**
             * for close modal and opening notification
             */
            closeModalAndOpen(modal) {
                this.$emit('close-and-open-modal', modal, [this.inputs],);
            },

            /**
             * get last Job Id (for save as template and create new advert)
             */
            getLastJobId() {
                this.axiosGet('admin/app/jobs').then(response => {

                    let lastJob = response.data.reduce(function(prev, current) {
                        if (+current.id > +prev.id) {
                            return current;
                        } else {
                            return prev;
                        }
                    });

                    this.newJobId = lastJob.id + 1;
                });
            },

            /**
             * create Empty onboarding sites
             */
            createOnboardingSites() {
                let selectedAddData = {
                    job: this.newJobId,
                };

                this.axiosPost({
                    url: 'bulk-add/onboardingsite',
                    data: selectedAddData
                }).then(response => {
                }).finally(() => {

                });
            },

            /**
             * Save as Template and Fill from Template
             */
            submitTemplate() {
                this.preloader = true;
                this.selectedUrl = '';
                this.inputs.status = 4;
                let _this = this;
                setTimeout(function(){ _this.save(_this.inputs); }, 1000);
            },
            getTemplateData() {
                let selectedTemplateId = parseInt(this.template);
                let templates = this.templateOptions;
                const selectedTemplate = templates.find(o => o.id === selectedTemplateId);

                this.finishedGetData = false;
                this.editorPreloader = true;
                this.inputs.location = selectedTemplate.location;
                this.inputs.title = selectedTemplate.title;
                this.inputs.advert = selectedTemplate.advert;
                this.inputs.note = selectedTemplate.note;


                let _this = this;
                setTimeout(function(){
                    _this.finishedGetData = true;
                    _this.editorPreloader = false;
                }, 500);
            },

            /**
             * Save form
             */
            submit() {
                // Create empty onboarding sites
                if (!this.selectedUrl) {

                    this.axiosGet('admin/app/jobs').then(response => {

                        let lastJob = response.data.reduce(function(prev, current) {
                            if (+current.id > +prev.id) {
                                return current;
                            } else {
                                return prev;
                            }
                            this.newJobId = lastJob.id + 1;
                        });
                    }).finally(() => {
                        this.createOnboardingSites();
                        this.save(this.inputs);
                    });


                } else {
                    this.save(this.inputs);
                }

            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                this.inputs = response.data;
                this.inputs.advert = response.data.advert;

                this.preloader = false;
                this.finishedGetData = true;

                // Add visited candidate to history
                if (history.replaceState && location.href.indexOf("?job") <= 0) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?job='+this.inputs.id;
                    window.history.replaceState({path:newurl},'',newurl);
                }
            },

            /**
             * Sharing
             */
            linkedInShare(url, title, descr) {
                if(this.inputs.status == 1){

                    let winWidth = 350;
                    let winHeight = 520;
                    let winTop = (screen.height / 2) - (winHeight / 2);
                    let winLeft = (screen.width / 2) - (winWidth / 2);
                    window.open('https://www.linkedin.com/sharing/share-offsite/?url='+escape(url) + '&title=' + document.title + '', '_blank', 'width=350,height=520');

                } else {
                    this.$toastr.w(this.$t('publish_before_share'));
                }
            },
            fbShare(url, title, descr, winWidth, winHeight) {
                if(this.inputs.status == 1){

                    let winTop = (screen.height / 2) - (winHeight / 2);
                    let winLeft = (screen.width / 2) - (winWidth / 2);
                    window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);

                } else {
                    this.$toastr.w(this.$t('publish_before_share'));
                }
            },
            twitterShare(url, title, descr, winWidth, winHeight) {
                if(this.inputs.status == 1){

                    let winTop = (screen.height / 2) - (winHeight / 2);
                    let winLeft = (screen.width / 2) - (winWidth / 2);
                    window.open('https://twitter.com/intent/tweet?text=' + this.$t("twitter_share_text") + descr + ' %0A' + url, 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);

                } else {
                    this.$toastr.w(this.$t('publish_before_share'));
                }

            },


            sanitizeTitle(job) {
                var slug = "";
                // Change to lower case
                var jobLower = job.toLowerCase();
                // Letter "e"
                slug = jobLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
                // Letter "a"
                slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
                // Letter "o"
                slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
                // Letter "u"
                slug = slug.replace(/u|ú|ů|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
                // Letter "d"
                slug = slug.replace(/đ/gi, 'd');
                // Letter "e"
                slug = slug.replace(/ě/gi, 'e');
                // Letter "s"
                slug = slug.replace(/š/gi, 's');
                // Letter "c"
                slug = slug.replace(/č/gi, 'c');
                // Letter "r"
                slug = slug.replace(/ř/gi, 'r');
                // Letter "z"
                slug = slug.replace(/ž/gi, 'z');
                // Letter "y"
                slug = slug.replace(/ý/gi, 'y');
                // Letter "i"
                slug = slug.replace(/í/gi, 'i');
                // Letter "n"
                slug = slug.replace(/ň/gi, 'n');
                // Trim the last whitespace
                slug = slug.replace(/\s*$/g, '');
                // Change whitespace to "-"
                slug = slug.replace(/\s+/g, '-');

                // Letter "i"
                slug = slug.replace(/\//gi, '-');

                return slug;
            },

            copyText() {

                let textToCopy = this.$refs.textToCopy.$el.querySelector('input');
                textToCopy.select();
                document.execCommand("copy");

                if(this.inputs.status == 1){
                    this.$toastr.s(this.$t('successfully_copied_url'));
                } else {
                   this.$toastr.w(this.$t('successfully_copied_url_advert_not_visible'));
                }

            },

            copyTextareaText() {
                let textareaValue = this.inputs.advert;
                textareaValue = this.htmlToPlainText(textareaValue);

                navigator.clipboard.writeText(textareaValue);

                this.$toastr.s(this.$t('successfully_copied_advert'));
            },

            htmlToPlainText(html) {
                let text = html;
                  text = text.replace(/\n/gi, "");
                  text = text.replace(/<div>/gi, "\n\n");
                  text = text.replace(/<style([\s\S]*?)<\/style>/gi, "");
                  text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
                  text = text.replace(/<a.*?href="(.*?)[\?\"].*?>(.*?)<\/a.*?>/gi, " $2 $1 ");
                  text = text.replace(/<\/div>/gi, "\n\n");
                  text = text.replace(/<\/li>/gi, "\n");
                  text = text.replace(/<li.*?>/gi, " •  ");
                  text = text.replace(/<\/ul>/gi, "\n\n");
                  text = text.replace(/<\/p>/gi, "\n\n");
                  text = text.replace(/<br\s*[\/]?>/gi, "\n");
                  text = text.replace(/&nbsp;/gi, " ");

                  text = text.replace(/<[^>]+>/gi, "");
                  text = text.replace(/^\s*/gim, "");
                  text = text.replace(/ ,/gi, ",");
                  text = text.replace(/ +/gi, " ");
                  text = text.replace(/\n+/gi, "\n\n");
                  return text;
            },


        },
    }
</script>
